import { z } from "zod";
import { ROLES } from "./roles.js";
import { CONTENT_KINDS, CONTENT_SCOPES, ANNOUNCEMENT_SEVERITIES } from "./content.js";
import { CTA_TYPES } from "./cta.js";
import { plainTextField } from "./public-api.js";
export const emailSchema = z.string().email().max(254);
export const bootstrapOwnerSchema = z.object({
    email: emailSchema,
    password: z.string().min(12).max(128),
    displayName: plainTextField(120),
});
export const createUserSchema = z.object({
    email: emailSchema,
    displayName: plainTextField(120),
    role: z.enum(ROLES),
    password: z.string().min(12).max(128),
});
export const siteCodeSchema = z
    .string()
    .min(3)
    .max(64)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Invalid site code format");
export const contentItemBaseSchema = z.object({
    kind: z.enum(CONTENT_KINDS),
    scope: z.enum(CONTENT_SCOPES),
    title: plainTextField(120),
    body: plainTextField(500),
    startsAt: z.coerce.date().nullable().optional(),
    endsAt: z.coerce.date().nullable().optional(),
    priority: z.number().int().min(0).max(1000).default(0),
});
export const announcementFieldsSchema = z.object({
    severity: z.enum(ANNOUNCEMENT_SEVERITIES),
    dismissible: z.boolean().default(false),
});
export const promotionFieldsSchema = z.object({
    badge: plainTextField(40).optional().default(""),
    ctaType: z.enum(CTA_TYPES).nullable().optional(),
    ctaLabel: plainTextField(60).optional().default(""),
    ctaHref: z.string().nullable().optional(),
    imageAlt: plainTextField(120).optional().default(""),
});
export function validateDateWindow(startsAt, endsAt) {
    if (startsAt && endsAt && endsAt <= startsAt)
        return false;
    return true;
}
export function isContentActiveNow(startsAt, endsAt, now = new Date()) {
    if (startsAt && now < startsAt)
        return false;
    if (endsAt && now >= endsAt)
        return false;
    return true;
}
//# sourceMappingURL=validation.js.map